export const ACTION_LOGIN = 'LOGIN';
export const ACTION_SIGNUP = 'SIGNUP';
export const CORRECT_PASSWORD = 'correctPassword';
export const DEFAULT_NOTIFICATIONS_PAGE_SIZE = 10;
export const DEFAULT_PAGE = 1;
export const DEFAULT_PAGE_SIZE = 50;
export const ID_EV_ALERTS = 'Alertas EV';
export const MSG_ERROR_RECAPTCHA = 'La verificación reCAPTCHA no fue superada correctamente. Por favor, intenta completar el proceso nuevamente.';